/**
 * FAQs for /compare/jev-benchmark, exported separately so routes.tsx can build
 * the FAQPage JSON-LD without pulling the page chunk (and its 460 KB of
 * benchmark data) into the route table. No figures here: every number on the
 * page comes from src/data/jev-benchmark/jev-class-comparison.v1.json through
 * the page's data.ts, and the answers stay true across releases.
 */
export const jevBenchmarkFaq: { q: string; a: string }[] = [
  {
    q: 'Why does LangWatch benchmark the model its own product runs on?',
    a: 'Instant Evals runs on Jev, so we wanted to know how far the open Jev-class models are from it before recommending either. We made real judgment calls along the way (the contamination rule, the framings, the decision thresholds, which caveats to show), and every one of them is written down on this page so you can check it. What we did not touch by hand is the ranking itself: the tie test decides who leads on the numbers.',
  },
  {
    q: 'Which model is the winner?',
    a: 'Each task shows its own leader, and two models in the same tier cannot be separated by the data. Grayed rows were trained on the task’s dataset; they are shown for reference and are not counted as the best open model.',
  },
  {
    q: 'What does a grayed row mean?',
    a: 'The model was trained on the test items or on another split of the same dataset, so its score measures memory of that dataset more than the skill. The contamination audit graded every model and task pair; the rule and the evidence are in the method section.',
  },
  {
    q: 'Why are some sources left out of the published numbers?',
    a: 'Two sources are licensed for non-commercial use only, so the moderation and RAG numbers here are recomputed without them. Two internal test sets are not shown at all. The audit also names sources that a trivial classifier solves; those stay in the headline, with the number without them next to it.',
  },
  {
    q: 'Is the latency comparable between the hosted model and the open ones?',
    a: 'Only within its kind. Open models ran one at a time on a laptop GPU, so their latency is laptop tier and a data-centre GPU is faster. Jev’s latency is measured from the same laptop and includes the network round trip to its API.',
  },
  {
    q: 'How is the cost per 1,000 decisions computed?',
    a: 'For the open models it is an assumption: a cloud-equivalent GPU rate times the measured time at concurrency 1, marked as assumed wherever it appears. Jev’s cost is not shown on this release: it is confidential under the vendor’s customer agreement until legal clears it for a public page.',
  },
  {
    q: 'Can I run the same judges on my own data?',
    a: 'Partly. Instant Evals runs the same hosted Jev judge over your own production history from the LangWatch CLI, so that half is the same judge. The open models are published weights you can serve yourself, but not with this benchmark’s exact setup: the harness, the framings and the decision thresholds used here are not public yet.',
  },
]
